/* eslint-disable import/no-cycle */
import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { IconButton, MenuItem } from '@mui/material'

import { globalTheme, globalTokens } from './global'

const getDayTextColor = ({ isToday, isSelected, isAnotherMonth }) => {
  if (isToday && !isSelected) return globalTheme.colors.neutral.low.dark
  if (isSelected) return globalTheme.colors.neutral.high.pure
  if (isAnotherMonth) return globalTheme.colors.neutral.low.medium

  return globalTheme.colors.neutral.low.dark
}

export const Calendar = styled('div')`
  max-width: 310px;
  padding: ${globalTokens.spacing.nano} ${globalTokens.spacing.XXXS};
`

export const Header = styled('div')`
  display: flex;
  flex-direction: column;
`

export const DateNavigation = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${globalTheme.colors.neutral.low.dark};
  line-height: ${globalTokens.lineHeights.XXXS};
  margin-bottom: ${globalTokens.spacing.XXXS};
`

export const DaysWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Week = styled('div')`
  display: flex;
  justify-content: space-between;
`

export const WeekdaysHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${globalTokens.spacing.quark};
`

export const WeekdayLabel = styled('div')`
  width: 36px;
  height: 28px;
  text-align: center;
  color: ${globalTheme.colors.neutral.high.medium};
  line-height: ${globalTokens.lineHeights.XS};
`

export const Day = styled('div')`
  ${({ isToday, isSelected, isAnotherMonth, isBetweenDates, rangeDate }) => css`
    width: 36px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${isBetweenDates ? globalTheme.colors.primary.light : 'transparent'};

    border-top-right-radius: ${rangeDate[1] ? '50%' : 'none'};
    border-bottom-right-radius: ${rangeDate[1] ? '50%' : 'none'};
    border-top-left-radius: ${rangeDate[0] ? '50%' : 'none'};
    border-bottom-left-radius: ${rangeDate[0] ? '50%' : 'none'};

    & button {
      height: 28px;
      width: 28px;
      color: ${getDayTextColor({ isToday, isSelected, isAnotherMonth })};
      font-size: ${globalTokens.fontSizes.XXS};
      line-height: ${globalTokens.lineHeights.XXS};
      font-weight: ${isToday ? globalTheme.fontWeights.black : globalTheme.fontWeights.regular};
      background-color: ${isSelected ? globalTheme.colors.primary.pure : 'none'};

      &:hover {
        background-color: ${isSelected ? globalTheme.colors.primary.medium : globalTheme.colors.primary.light};
      }
    }
  `}
`

export const NavigationButton = styled(IconButton)`
  color: ${globalTheme.colors.primary.pure};
`

export const PaperWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`

export const PaperContent = styled('div')`
  display: flex;
`

export const PaperFooter = styled('div')`
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid ${globalTheme.colors.neutral.high.light};
  padding: ${globalTokens.spacing.nano};
  gap: ${globalTokens.spacing.nano};
`

export const VerticalLine = styled('div')`
  border-left: 1px solid ${globalTheme.colors.neutral.high.light};
`

export const Item = styled(MenuItem)`
  padding: ${globalTokens.spacing.nano} ${globalTokens.spacing.XXS};
  background-color: ${({ isSelected }) => (isSelected ? globalTheme.colors.primary.light : 'none')};
`

export const CustomTimeWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100px;
  gap: ${globalTokens.spacing.XXS};
`

export const TimeWrapper = styled('div')`
  display: flex;
  gap: ${globalTokens.spacing.XXS};
  margin: ${globalTokens.spacing.XXXS} ${globalTokens.spacing.XXS};
`
export const ItemsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  padding-top: ${globalTokens.spacing.nano};
`
